<template>
  <div class="flex justify-center min-h-screen">
    <div>
      <div class="p-5 mt-10 bg-white md:p-10 rounded-2xl">
        <div class="w-98">
          <progress-bar
            :step="step"
            :total-steps="totalSteps"
          />
          <onboarding-questions-step
            v-if="step===0"
            :onboarding-steps="onboardingSteps"
            @next="nextStep"
          />
          <create-entity-step
            v-if="step===1"
            @next="nextStep"
          />
          <fintoc-step
            v-else-if="step===2"
            :entity-id="entityId"
            @next="nextStep"
            @back="back"
          />
          <success-step
            v-else-if="step===3"
            @next="finish"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapWritableState } from 'pinia';
import { useOnboardingWizardStore } from '../../stores/onboarding-wizard';
import OnboardingQuestionsStep from './onboarding-questions-step.vue';
import CreateEntityStep from './create-entity-step.vue';
import FintocStep from './fintoc-step.vue';
import SuccessStep from './success-step.vue';
import ProgressBar from './progress-bar.vue';

export default {
  beforeMount() {
    this.fintocAccountConnected = false;
  },
  components: { CreateEntityStep, SuccessStep, FintocStep, ProgressBar, OnboardingQuestionsStep },
  data() {
    return {
      step: 0,
      loading: false,
      totalSteps: 3,
    };
  },
  props: {
    onboardingSteps: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    if (this.onboardingSteps.length === 0) {
      this.nextStep();
    }
  },
  methods: {
    back() {
      this.step -= 1;
    },
    nextStep() {
      this.step += 1;
    },
    finish() {
      this.step += 1;
      window.location.href = `/entities/${this.entityId}/bank_movements`;
    },
  },
  computed: {
    ...mapWritableState(useOnboardingWizardStore, [
      'firstEntityId',
      'fintocAccountConnected',
    ]),
    entityId: {
      get() {
        return this.firstEntityId;
      },
    },
  },
};
</script>
